import { useCallback } from "react";
import { UpgradeScenarioConfig } from "../components/modal/UpgradeReminder/types";
import { errorCode } from "@config/error";

import { useMemberUser } from "./useMemberUser";
import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/hooks/useSearchEquity";

const I18n = I18nUtil.createScoped(Translations);

/**
 * Configuration for search equity upgrade reminder
 * Extends UpgradeScenarioConfig with additional properties
 */

/**
 * Result of useSearchEquity hook
 */
export interface UseSearchEquityResult {
  getCreditConfig?: (errCode?: number) => UpgradeScenarioConfig | null;
}

const creditConfig = {
  title: "Search Credit Limit Reached",
  content: [
    "Upgrade for a higher credit allowance",
    "Extra Aura",
    "More Searches, tools, and access",
  ],
  highlightFirstItem: true,
};

/**
 * Hook for managing search equity upgrade reminder configuration
 * Returns different configurations based on member plan level
 */
export const useSearchEquity = (): UseSearchEquityResult => {
  const { data: memberInfo, isLoading } = useMemberUser();

  //提供外部传入 code 码，返回对应的配置
  const getCreditConfig = useCallback(
    (errCode?: number): UpgradeScenarioConfig | null => {
      if (
        isLoading ||
        (errCode !== errorCode.CREDITS_LIMITED &&
          errCode !== errorCode.CREDIT_NOT_ENOUGH)
      ) {
        return null;
      }
      const btnConfig = memberInfo?.isFree
        ? {
            buttonText: "Upgrade",
            buttonAction: "upgrade" as const,
          }
        : {
            buttonText: I18n.t("Contact Us"),
            buttonAction: "contactSales" as const,
          };
      return {
        ...creditConfig,
        ...btnConfig,
      };
    },
    [isLoading, memberInfo?.isFree],
  );

  return {
    getCreditConfig,
  };
};
